<div class="flex px-2 py-1 gap-1 rounded-[8px] border border-[#D7D7D7] bg-white text-base">
  @for (option of options; track option.value) {
    <button type="button" (click)="select(option.value)"
      class="flex h-[35px] px-8 py-2 justify-center items-center gap-2 rounded-[8px] text-sm font-medium transition"
      [ngClass]="option.value === selected ? 'bg-[#FBEBEF] text-rutgers-red' : 'text-stone-500 hover:bg-gray-200'">
      {{option.label}}
    </button>
  }
</div>
